import StructuredEventProperty from './StructuredEventProperty';

export default class ErrorEventProperty extends StructuredEventProperty {
  static override readonly type: number = 9;
  static override readonly label: string = 'Error event property';
  static override readonly indexProps = [
    { index: 1, label: 'message' },
    { index: 2, label: 'filename' },
    { index: 3, label: 'lineNumber' },
    { index: 4, label: 'columnNumber' },
    { index: 5, label: 'error' },
  ];
}
